import React, { useState, useEffect } from 'react';
import './ShippingMethod.css';
import { MONTHS, WEEKDAYS_FULL } from '../../../constants/DateConstants';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const DateCell = (props) => {
  const { t, i18n } = useTranslation();
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  return (
    <div onClick={selectDate} style={{ backgroundColor: props.isSelected ? mainColor : "#EFEFEF", opacity: props.dateInfo.noAvailabilities ? 0.5 : 1.0 }} className={"DateCell " + (props.index === 6 ? "" : "DateCellBorderRight ")}>
      <p className={"WeekdayHeaderText " + (props.isSelected ? "DatePickerTextWhite" : "DatePickerTextBlack")}>{t(props.weekdayHeader)}</p>
      <p className={"DateText " + (props.isSelected ? "DatePickerTextWhite" : "DatePickerTextBlack")}>{props.dateInfo.date}</p>
      <p className={"MonthText " + (props.isSelected ? "DatePickerTextWhite" : "DatePickerTextBlack")}>{t(props.dateInfo.monthText)}</p>
    </div>
  )
  function selectDate() {
    if (props.dateInfo.noAvailabilities !== true) {
      props.onSelect(props.dateInfo.apiDate, props.dateInfo);
    }
  }
}

export default DateCell;